import React, { useState } from 'react';
import { Stepper } from './components/Stepper';
import { UploadDrawing } from './components/sections/UploadDrawing';
import { AIExtraction } from './components/sections/AIExtraction';
import { RoomsAndManifolds } from './components/sections/RoomsAndManifolds';
import { Parameters } from './components/sections/Parameters';
import { FlowData } from './components/sections/FlowData';
import { MaterialList } from './components/sections/MaterialList';
import { StatusBar } from './components/common/StatusBar';
export function App() {
  const [activeStep, setActiveStep] = useState(0);
  const steps = [{
    id: 0,
    title: 'Upload tegning'
  }, {
    id: 1,
    title: 'AI-udtræk'
  }, {
    id: 2,
    title: 'Rum & manifolder'
  }, {
    id: 3,
    title: 'Parametre'
  }, {
    id: 4,
    title: 'Flowdata'
  }, {
    id: 5,
    title: 'Materialeliste & pris'
  }];
  const handleNext = () => {
    if (activeStep < steps.length - 1) {
      setActiveStep(activeStep + 1);
    }
  };
  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1);
    }
  };
  const renderStep = () => {
    switch (activeStep) {
      case 0:
        return <UploadDrawing onNext={handleNext} data-id="element-0" />;
      case 1:
        return <AIExtraction onNext={handleNext} onBack={handleBack} data-id="element-1" />;
      case 2:
        return <RoomsAndManifolds onNext={handleNext} onBack={handleBack} data-id="element-2" />;
      case 3:
        return <Parameters onNext={handleNext} onBack={handleBack} data-id="element-3" />;
      case 4:
        return <FlowData onNext={handleNext} onBack={handleBack} data-id="element-4" />;
      case 5:
        return <MaterialList onBack={handleBack} data-id="element-5" />;
      default:
        return <UploadDrawing onNext={handleNext} data-id="element-6" />;
    }
  };
  return <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-7">
      <header className="w-full bg-white shadow-sm py-4 px-6" data-id="element-8">
        <div className="max-w-7xl mx-auto" data-id="element-9">
          <h1 className="text-2xl font-bold text-gray-800" data-id="element-10">
            Tilbudsmotor – AI fra tegning → rum & flowdata
          </h1>
        </div>
      </header>
      <main className="flex-1 w-full" data-id="element-11">
        <div className="max-w-7xl mx-auto px-4 py-6" data-id="element-12">
          <Stepper steps={steps} activeStep={activeStep} onStepClick={setActiveStep} data-id="element-13" />
          <div className="mt-8" data-id="element-14">{renderStep()}</div>
        </div>
      </main>
      <StatusBar projectId="P-12345" customerId="Bygherre A/S" status={[activeStep > 1 ? 'AI-udtræk godkendt' : null, activeStep > 3 ? 'Parametre låst' : null, activeStep > 4 ? 'Flow beregnet' : null].filter(Boolean)} data-id="element-15" />
    </div>;
}